import { DonutChart } from "@/components/organisms/DonutChart/DonutChart";
import { RawData } from "@/modules/dashboard/domain/entities/DashboardEntity";
import { DashboardGraphicsDonutChartsProps } from "./DashboardGraphicsFilters.types";

const groupByField = (rawData: RawData[], field: keyof RawData) => {
    const map = new Map<string, number>();
    rawData.forEach((item) => {
        const key = String(item[field]).trim();
        map.set(key, (map.get(key) ?? 0) + item.localCurrencyValuation);
    });
    const total = Array.from(map.values()).reduce((sum, v) => sum + v, 0);
    return Array.from(map.entries()).map(([name, value]) => ({
        name,
        value,
        percent: value / total,
    }));
};

export const DashboardGraphicsDonutCharts = ({ data, fieldsSelected, graphicsOptions }: DashboardGraphicsDonutChartsProps) => {
    const slots = [0, 1, 2] as const;

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-1">
            {slots.map((idx) => {
                const field = fieldsSelected[idx];
                if (field) {
                    const chartData = groupByField(data, field);
                    const label = graphicsOptions.find((o) => o.value === field)?.label;

                    return (
                        <div
                            key={idx}
                            className="aspect-[3/2] bg-gray-100 dark:bg-gray-700 rounded p-4 pb-6"
                        >
                            <h3 className="text-md font-semibold mb-2">{label}</h3>
                            <DonutChart data={chartData} />
                        </div>
                    );
                }

                return (
                    <div
                        key={idx}
                        className="aspect-[3/2] bg-gray-50 dark:bg-[--secondary-900] rounded border-2 border-dashed border-gray-300 dark:border-gray-600 flex items-center justify-center p-4"
                    >
                        <p className="text-gray-500 dark:text-gray-400 text-center">
                            Selecciona {idx + 1}ª métrica
                        </p>
                    </div>
                );
            })}
        </div>
    );
};
